import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
// NGX Permissions
import { NgxPermissionsModule } from './shared/modules/ngx-permissions';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthGuard, RequestService, StoreService, LoggerService, GlobalErrorHandler, LoaderService, TabCoordinatorService } from './shared';
import { LayoutUtilsService, MenuConfigService, ResizeService, SubheaderService } from './shared/services';
import { UserDefaultsService } from './shared';
import { PageScopeService, UrlHelperService } from './shared/services';
import { SharedModule } from './shared/shared.module';
import { LayoutComponentModule } from './shared/layout.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CookieService } from 'ngx-cookie-service';
import { ImageCropperModule } from 'ngx-image-cropper';
import { GoogleMapsModule } from "@angular/google-maps";
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
// import { VonageService } from './shared/services/vonage.service';
import { DateLocaleProvider, MAT_DATE_LOCALE_PROVIDER } from './shared/providers';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { SignalingService } from './shared/services/signaling.service';
import { CustomPaginatorIntl } from './shared/providers/custom-paginator-intl';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { FirebaseAuthService } from './shared/services/firebase-auth.service';
import { ChatService } from './shared/services/chat.service';
import { CaseService } from './shared/services/case.service';
import { NotificationsHandlersService } from './shared/services/notifications-handlers.service';
import { RouteReuseStrategy, Router } from '@angular/router';
import { CaseDashboardReuseStrategy } from './shared/services/case-dashboard-reuse.strategy';
import * as Sentry from "@sentry/angular";
import { TemplateTranslateLoader } from './shared/loaders/template-translate-loader';
import { AuthInterceptor } from './shared/services/interceptors/auth.interceptor';

// AoT requires an exported function for factories
export const createTranslateLoader = (http: HttpClient) => {
  return new TemplateTranslateLoader(http, './assets/i18n/', '.json');
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    // NgxGraphModule,
    GoogleMapsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    OverlayModule,
    SharedModule,
    LayoutComponentModule,
    HttpClientModule,
    ImageCropperModule,
    NgIdleKeepaliveModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AuthGuard,
    RequestService,
    TabCoordinatorService,
    LoaderService,
    StoreService,
    LayoutUtilsService,
    MenuConfigService,
    SubheaderService,
    LoggerService,
    CookieService,
    UserDefaultsService,
    PageScopeService,
    UrlHelperService,
    // VonageService,
    ChatService,
    CaseService,
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    SignalingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
    NotificationsHandlersService,
    // { provide: MAT_DATE_LOCALE, useValue: 'en' },
    DateLocaleProvider, MAT_DATE_LOCALE_PROVIDER,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    // { provide: RollbarService, useFactory: rollbarFactory },
    FirebaseAuthService,
    ResizeService,
    { provide: RouteReuseStrategy, useClass: CaseDashboardReuseStrategy },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
